/* eslint-disable */

export enum CapabilityName {
  /** UNDEFINED - An unknown value was found */
  UNDEFINED = "UNDEFINED",
  /** CRYPTO_BITCOIN - All Bitcoin functionality */
  CRYPTO_BITCOIN = "CRYPTO_BITCOIN",
  /** CRYPTO_BITCOIN_P2P - Bitcoin sending off-chain functionality */
  CRYPTO_BITCOIN_P2P = "CRYPTO_BITCOIN_P2P",
  /** CRYPTO_BITCOIN_DEPOSIT - Ability to deposit Bitcoin to a CashApp address (on-chain transaction) */
  CRYPTO_BITCOIN_DEPOSIT = "CRYPTO_BITCOIN_DEPOSIT",
  /** CRYPTO_BITCOIN_WITHDRAW - Ability to withdraw Bitcoin from CashApp to an external wallet address (on-chain transaction) */
  CRYPTO_BITCOIN_WITHDRAW = "CRYPTO_BITCOIN_WITHDRAW",
  /**
   * CRYPTO_BITCOIN_LIGHTNING - All Bitcoin functionalities on lightning network
   *
   * @deprecated
   */
  CRYPTO_BITCOIN_LIGHTNING = "CRYPTO_BITCOIN_LIGHTNING",
  /** CARDS - All cards functionality including the visibility of the cards tab, linking cards in onboarding etc */
  CARDS = "CARDS",
  /** INVESTING - All investing functionality including the visibility of the investing tab */
  INVESTING = "INVESTING",
  /** BANKING - Visibility of the banking tab */
  BANKING = "BANKING",
  /** FIAT_P2P - Ability to send and receive fiat p2p payments */
  FIAT_P2P = "FIAT_P2P",
  /** FIAT_P2P_MULTI_CURRENCY_SELECTION - Visibility of the fiat currency selection */
  FIAT_P2P_MULTI_CURRENCY_SELECTION = "FIAT_P2P_MULTI_CURRENCY_SELECTION",
  /** ONBOARDING_IDV_INTERNATIONAL - Visibility of international IDV requirements in onboarding flow */
  ONBOARDING_IDV_INTERNATIONAL = "ONBOARDING_IDV_INTERNATIONAL",
  /** CRYPTO_BITCOIN_LIGHTNING_DEPOSIT - Ability to deposit Bitcoin to CashApp via lightning network */
  CRYPTO_BITCOIN_LIGHTNING_DEPOSIT = "CRYPTO_BITCOIN_LIGHTNING_DEPOSIT",
  /** CRYPTO_BITCOIN_LIGHTNING_WITHDRAW - Ability to withdraw Bitcoin from CashApp to an external lightning wallet via lightning network */
  CRYPTO_BITCOIN_LIGHTNING_WITHDRAW = "CRYPTO_BITCOIN_LIGHTNING_WITHDRAW",
  /** CRYPTO_BITCOIN_BUY_MARKET - Ability to create and execute Market Bitcoin BUY Orders (fiat currency -> BTC). */
  CRYPTO_BITCOIN_BUY_MARKET = "CRYPTO_BITCOIN_BUY_MARKET",
  /** CRYPTO_BITCOIN_SELL_MARKET - Ability to create and execute Market Bitcoin SELL Orders (BTC -> fiat currency). */
  CRYPTO_BITCOIN_SELL_MARKET = "CRYPTO_BITCOIN_SELL_MARKET",
  /** CRYPTO_BITCOIN_BUY_CUSTOM - Ability to create and execute Custom (Limit) Bitcoin BUY Orders (fiat currency -> BTC). */
  CRYPTO_BITCOIN_BUY_CUSTOM = "CRYPTO_BITCOIN_BUY_CUSTOM",
  /** CRYPTO_BITCOIN_SELL_CUSTOM - Ability to create and execute Custom (Limit) Bitcoin SELL Orders (BTC -> fiat currency). */
  CRYPTO_BITCOIN_SELL_CUSTOM = "CRYPTO_BITCOIN_SELL_CUSTOM",
  /** CRYPTO_BITCOIN_AUTO_INVEST_BUY - Ability to create recurring Market Bitcoin BUY Orders AKA Auto-Invest. */
  CRYPTO_BITCOIN_AUTO_INVEST_BUY = "CRYPTO_BITCOIN_AUTO_INVEST_BUY",
  /**
   * CRYPTO_BITCOIN_PAYROLL - Ability to configure the Bitcoin Payroll feature and execute Payroll related Orders.
   * AKA Paid In Bitcoin.
   */
  CRYPTO_BITCOIN_PAYROLL = "CRYPTO_BITCOIN_PAYROLL",
  /** CRYPTO_BITCOIN_ROUNDUP - Ability to configure the Bitcoin Roundups feature and execute Roundup related Orders. */
  CRYPTO_BITCOIN_ROUNDUP = "CRYPTO_BITCOIN_ROUNDUP",
  /** CRYPTO_BITCOIN_BOOSTS - Ability to configure Bitcoin related Boosts and execute Boost related Orders. */
  CRYPTO_BITCOIN_BOOSTS = "CRYPTO_BITCOIN_BOOSTS",
  /** CRYPTO_BITCOIN_GIFTING - Ability to send or receive Bitcoin related Gifts and execute Gifting related Orders. */
  CRYPTO_BITCOIN_GIFTING = "CRYPTO_BITCOIN_GIFTING",
  /** CRYPTO_XUS - All USDC functionality. */
  CRYPTO_XUS = "CRYPTO_XUS",
  /** CRYPTO_FIAT_TO_XUS_MARKET - Ability to create and execute an exchange from fiat currency to USDC. */
  CRYPTO_FIAT_TO_XUS_MARKET = "CRYPTO_FIAT_TO_XUS_MARKET",
  /** CRYPTO_BTC_TO_XUS_MARKET - Ability to create and execute an exchange from BTC to USDC. */
  CRYPTO_BTC_TO_XUS_MARKET = "CRYPTO_BTC_TO_XUS_MARKET",
  /** CRYPTO_XUS_TO_BTC_MARKET - Ability to create and execute an exchange from USDC to BTC. */
  CRYPTO_XUS_TO_BTC_MARKET = "CRYPTO_XUS_TO_BTC_MARKET",
  /** CRYPTO_XUS_TO_FIAT_MARKET - Ability to create and execute an exchange from USDC to fiat currency. */
  CRYPTO_XUS_TO_FIAT_MARKET = "CRYPTO_XUS_TO_FIAT_MARKET",
}

export enum CapabilityStatus {
  /** AVAILABLE - Capability is available */
  AVAILABLE = "AVAILABLE",
  /** UNAVAILABLE - Capability is unavailable */
  UNAVAILABLE = "UNAVAILABLE",
}

export interface MarketCapability {
  name?: CapabilityName;
  status?: CapabilityStatus;
  reason?: string;
}
